    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var i = visible.indexOf(e.target);
        if (e.isIntersecting) {
          if (i === -1) visible.push(e.target);
        } else {
          if (i !== -1) visible.splice(i, 1);
          if (!e.target.paused) { try { e.target.pause(); } catch (err) {} }
        }
      });
      apply();
    }, {
      // a little before it arrives, but not so far ahead that a tall viewport
      // starts half the page
      rootMargin: '80px 0px',
      threshold: 0.01
    });

/* ===================================================================
   KAAYU - LAZY BACKGROUND VIDEO
   Used by sections/shoppable-video-carousel.liquid and
   sections/kaayu-celeb-spotted.liquid.

   THE PROBLEM THIS SOLVES
   The homepage was shipping 157.9 MB, 154.3 MB of it video across 19
   requests. Five of those files - 37.3, 27.3, 19.3, 12.3 and 11.8 MB, all
   1080p or 720p - were decoding at the same time, in elements rendered
   220 CSS pixels wide. Two decisions caused it:

     1. Every <video> was play()ed in a loop as soon as the script ran,
        before any of them were on screen.
     2. The carousel's own observer only ever started playback and, by an
        explicit comment, never paused on scroll-out. So once a video had
        been seen it decoded for the rest of the session.

   WHAT THIS DOES INSTEAD
   A video plays only while it is actually on screen and pauses the moment
   it leaves. Combined with preload="none" in the markup, nothing is
   fetched until it is about to be seen.

   ON AUTOPLAY POLICY
   Pausing does not cost us anything here. These videos are muted, and a
   muted video may be played from script without a user gesture, so
   resuming when it scrolls back into view is allowed. That was the stated
   reason for never pausing, and it does not hold.

   ON REDUCED MOTION
   Anyone who has asked for reduced motion gets the poster frame and a
   paused video with controls, not looping footage.
   =================================================================== */
(function () {
  'use strict';

  var SELECTOR = 'video[data-kv-lazy]';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Hard cap on simultaneous decodes.
  //
  // A first attempt evicted the oldest video whenever a new one started. That
  // capped nothing: the evicted video was still on screen, so the very next
  // observer callback saw `paused === true` and started it again. The two
  // rules fought and the count settled at seven rather than four.
  //
  // This decides the whole set at once instead. Every intersecting video is
  // ranked by how close its centre is to the centre of the viewport; the
  // nearest four play and everything else pauses. Nothing can restart a video
  // the policy has just stopped, because the policy is recomputed as one pass.
  var MAX_PLAYING = 4;
  var visible = [];

  function distanceFromCentre(v) {
    var r = v.getBoundingClientRect();
    return Math.abs((r.top + r.height / 2) - (window.innerHeight / 2));
  }

  function apply() {
    if (reduced) return;
    var ranked = visible.slice().sort(function (a, b) {
      return distanceFromCentre(a) - distanceFromCentre(b);
    });
    ranked.forEach(function (v, i) {
      if (i < MAX_PLAYING) {
        if (v.paused) {
          // preload="none" means nothing is buffered yet; play() starts the
          // fetch, which is the point - it happens on approach, not on load
          var r = v.play();
          if (r && typeof r.catch === 'function') r.catch(function () {});
        }
      } else if (!v.paused) {
        try { v.pause(); } catch (e) {}
      }
    });
  }

  function init() {
    var vids = document.querySelectorAll(SELECTOR);
    if (!vids.length) return;

    if (reduced) {
      Array.prototype.forEach.call(vids, function (v) {
        v.removeAttribute('autoplay');
        v.setAttribute('controls', '');
        try { v.pause(); } catch (e) {}
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      // no observer: play them, but still only the first few, so an old
      // browser is slow rather than unusable
      Array.prototype.forEach.call(vids, function (v, i) {
        if (i < 2) { var r = v.play(); if (r && r.catch) r.catch(function () {}); }
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      // maintain the visible set only; apply() decides what actually plays
      entries.forEach(function (e) {
        var i = visible.indexOf(e.target);
        if (e.isIntersecting) {
          if (i === -1) visible.push(e.target);
        } else {
          if (i !== -1) visible.splice(i, 1);
          if (!e.target.paused) { try { e.target.pause(); } catch (err) {} }
        }
      });
      apply();
    }, {
      // a little before it arrives, but not so far ahead that a tall viewport
      // starts half the page
      rootMargin: '80px 0px',
      threshold: 0.01
    });

    Array.prototype.forEach.call(vids, function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
      v.removeAttribute('autoplay');
      io.observe(v);
    });

    // a tab in the background should not be decoding video either
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), function (v) {
          try { v.pause(); } catch (e) {}
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
